import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { AddressLabel, HttpService, NotificationService, TmsWebBaseEditCreateCopyService } from 'tms-lib';
import {
  CreatedPurchaseOrder,
  CreatedPurchaseOrderFromContracts,
  PurchaseOrderEmailContacts,
  PurchaseOrderHeader,
  PurchaseOrderHeaderDetails,
} from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderService extends TmsWebBaseEditCreateCopyService<
  PurchaseOrderHeader,
  PurchaseOrderHeaderDetails
> {
  public refreshDetails = new Subject<void>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('PurchaseOrder', $localize`Purchase Order Header`, httpService, notificationService);
  }

  getPurchaseOrderHeader(id: string): Observable<PurchaseOrderHeader> {
    return this.httpService.get<PurchaseOrderHeader>(`${this.apiUrl}/PurchaseOrder?id=${id}`);
  }

  getPurchaseOrderEmailContacts(id: string): Observable<PurchaseOrderEmailContacts> {
    return this.httpService.get<PurchaseOrderEmailContacts>(`${this.apiUrl}/PurchaseOrderEmailContacts?id=${id}`);
  }

  createPurchaseOrder(
    ids: string[],
    balances: number[],
    bespokeQuantity: number[],
    complete: boolean,
  ): Observable<string[]> {
    return this.httpService.post<string[]>(`${this.apiUrl}/CreatePurchaseOrder`, {
      ids,
      balances,
      bespokeQuantity,
      complete,
    });
  }

  autoCreatePurchaseOrder(ids: string[], balances: number[], complete: boolean): Observable<string[]> {
    return this.httpService.post<string[]>(`${this.apiUrl}/AutoCreatePurchaseOrder`, { ids, balances, complete });
  }

  getCreatedPurchaseOrders(ids: string[]): Observable<CreatedPurchaseOrder[]> {
    return this.httpService.post<CreatedPurchaseOrder[]>(`${this.apiUrl}/CreatedPurchaseOrders`, { ids });
  }

  getDeliveryAddress(id: string): Observable<AddressLabel> {
    return this.httpService.get<AddressLabel>(`${this.apiUrl}/GetDeliveryAddress?id=${id}`);
  }

  confirmOrder(id: string): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/ConfirmOrder`, { id });
  }

  createPurchaseOrderFromContracts(
    ids: string[],
    balances: number[],
    salesOrderLineRef: string,
    unitOfMeasureId: string,
    complete: boolean,
  ): Observable<string[]> {
    return this.httpService.post<string[]>(`${this.apiUrl}/CreatePurchaseOrderFromContracts`, {
      ids,
      balances,
      salesOrderLineRef,
      unitOfMeasureId,
      complete,
    });
  }

  getCreatedPurchaseOrdersFromContracts(ids: string[]): Observable<CreatedPurchaseOrderFromContracts[]> {
    return this.httpService.post<CreatedPurchaseOrderFromContracts[]>(
      `${this.apiUrl}/CreatedPurchaseOrdersFromContracts`,
      { ids },
    );
  }
}
